<template>
  <div>
    <el-input
      v-model.trim="formData.value"
      :placeholder="formData.placeholder"
      :clearable="formData.clearable"
      :size="formData.size || size"
      @clear="clear"
      @input="input"
    >
      <el-button
        v-if="formData.multiple"
        slot="append"
        :size="formData.size || size"
        @click="openAppend"
      >
        {{ formData.append }}
      </el-button>
    </el-input>
    <el-dialog :title="`${formData.append}搜索`" width="554px" :visible.sync="multipleShow">
      <div class="title">{{ formData.multipleLabel }}</div>
      <el-input
        class="dialog-textarea"
        type="textarea"
        :placeholder="formData.multiplePlaceholder"
        v-model.trim="textarea"
      >
      </el-input>
      <div slot="footer" class="input-footer">
        <div class="footer-left pointer _F36807" @click="clearAll">
          <i class="el-icon-delete"></i>
          清除全部
        </div>
        <div class="footer-right">
          <el-button size="small" @click="multipleShow = false">取消</el-button>
          <el-button size="small" type="primary" @click="onSure">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'nf-input',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      multipleShow: false,
      textarea: '',
    };
  },
  methods: {
    input(e) {
      if (e.length > 0) {
        this.value = '';
        this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
          index: this.index,
          value: e.trim(),
        });
      }
    },
    clear() {
      this.value = '';
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: '',
      });
      this.$store.dispatch(`${this.storeModelName}/getList`);
    },
    openAppend() {
      this.textarea = this.formData.value;
      this.multipleShow = true;
    },
    clearAll() {
      this.textarea = '';
    },
    onSure() {
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: this.textarea.replace(/\n/g, ','),
      });
      this.multipleShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 0 30px;
}

.title {
  height: 14px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #181818;
  line-height: 14px;
}

.dialog-textarea {
  width: 494px;
  height: 208px;
  border-radius: 3px;
  border: 1px solid #eaebef;
  margin-top: 15px;

  ::v-deep .el-textarea__inner {
    border: 0;
    height: 100%;
  }
}

.input-footer {
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
}
</style>
